var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_4072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 4.25C14.0625 4.25 10.125 5.375 10.125 10.4375V14.375C10.125 15.616 11.134 16.625 12.375 16.625H13.5V21.125C13.5 21.7473 14.0027 22.25 14.625 22.25C15.2473 22.25 15.75 21.7473 15.75 21.125V16.625V12.6875V5.375C15.75 4.75273 15.2473 4.25 14.625 4.25ZM2.25 4.8125C2.25 4.52422 2.03555 4.28516 1.74727 4.25352C1.45898 4.22188 1.20234 4.41172 1.13906 4.68945L0.0738281 9.48125C0.0246094 9.70273 0 9.92773 0 10.1527C0 11.7664 1.23398 13.0918 2.8125 13.2359V21.125C2.8125 21.7473 3.31523 22.25 3.9375 22.25C4.55977 22.25 5.0625 21.7473 5.0625 21.125V13.2359C6.64102 13.0918 7.875 11.7664 7.875 10.1527C7.875 9.92773 7.85039 9.70273 7.80117 9.48125L6.73594 4.68945C6.67266 4.4082 6.40898 4.22188 6.12422 4.25352C5.83945 4.28516 5.625 4.52422 5.625 4.8125V9.53047C5.625 9.72031 5.47031 9.875 5.28047 9.875C5.10117 9.875 4.95352 9.73789 4.93594 9.55859L4.49648 4.76328C4.47188 4.47148 4.2293 4.25 3.9375 4.25C3.6457 4.25 3.40313 4.47148 3.37852 4.76328L2.94258 9.55859C2.925 9.73789 2.77734 9.875 2.59805 9.875C2.4082 9.875 2.25352 9.72031 2.25352 9.53047V4.8125H2.25ZM3.94805 10.1562H3.9375H3.92695L3.9375 10.1316L3.94805 10.1562Z",
    fill: "#2F80ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_4072"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.25H15.75V22.25H0V4.25Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.801c680c630fad82904684f3477ce2aa.svg";
export { ForwardRef as ReactComponent };